import { BaseApiService } from "../../../api/base";
import type {
  UserKycState,
  UserKyc,
  UserIdentityCard,
  UpdateAddressRequest,
  ProofOfAddressDocumentType,
} from "../types/kyc";

class KycApiService extends BaseApiService {
  async getUserKyc(): Promise<UserKyc> {
    return this.get<UserKyc>("/kyc");
  }

  async getUserKycState(): Promise<UserKycState> {
    return this.get<UserKycState>("/kyc/state");
  }

  async requestKycSession(isExpired?: boolean): Promise<UserKyc> {
    return this.post<UserKyc>("/kyc/request", {
      isExpired,
    });
  }

  async getUserIdentityCard(): Promise<UserIdentityCard> {
    return this.get<UserIdentityCard>("/kyc/identity-card");
  }

  async updateAddress(request: UpdateAddressRequest): Promise<UserKycState> {
    return this.post<UserKycState>("/kyc/identity-card/address", request);
  }

  async uploadProofOfAddress(
    file: File,
    documentType: ProofOfAddressDocumentType,
  ): Promise<UserKycState> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("documentType", documentType);
    return this.post<UserKycState>(
      "/kyc/identity-card/proof-of-address",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  }
}

export const kycApiService = new KycApiService();
